import React from "react";
import { FunnelChart, Tooltip, Funnel } from "recharts";
import { ChartStrategy } from "./ChartStrategy";

export class FunnelChartStrategy extends ChartStrategy {
  render() {
    return (
      <FunnelChart>
        <Tooltip content={<this.props.CustomTooltip />} />
        <Funnel
          data={this.props.normalizedData}
          dataKey={this.props.yAxis}
          nameKey={this.props.xAxis}
        />
      </FunnelChart>
    );
  }
}
